import { isLineItemReorderable } from "../../../../../utils/Orders/utils/is-line-item-reorderable.js";
import { isContactLensesOrderLineItem } from "../../../../view/utils/Orders/mappers/view/utils/order-line-item-product-type-guards.js";
const toEyeSide = (eyeSide) => {
  switch (eyeSide) {
    case "LEFT":
      return "left";
    case "RIGHT":
      return "right";
    case "BOTH":
      return "both";
    default:
      return void 0;
  }
};
const convertLineItemToDraft = (orderLineItem) => {
  const draft = {
    quantity: orderLineItem.quantity,
    sku: orderLineItem.product.sku,
    type: "regular"
  };
  if (isContactLensesOrderLineItem(orderLineItem)) {
    const { __typename, ...contactLensPrescription } = orderLineItem.prescription;
    return {
      ...draft,
      type: "contact-lenses",
      typeDetails: {
        eyeSide: toEyeSide(orderLineItem.eyeSide),
        contactLensPrescription
      }
    };
  }
  return draft;
};
const toDrafts = (orderLineItems) => {
  if (!orderLineItems) {
    return {};
  }
  return Object.fromEntries(
    orderLineItems.filter(isLineItemReorderable).map((lineItem) => [lineItem.id, convertLineItemToDraft(lineItem)])
  );
};
export {
  toDrafts
};
//# sourceMappingURL=to-drafts.js.map
